<template>
  <div>
    <div class="row">
      <div class="col-12 col-md-6">
        <h4 class="f-bold pt-2 pl-3 cl-primary text-left">Data Services</h4>
      </div>
      <div class="col-12 col-md-6">
        <nav aria-label="breadcrumb">
          <ol
            class="breadcrumb float-right"
            style="background-color: transparent"
          >
            <li class="breadcrumb-item">
              <router-link to="/admin/dashboard">Dashboard</router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Data Services
            </li>
          </ol>
        </nav>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <button
          class="btn btn-primary float-right px-4 my-2"
          @click.prevent="servicesForm"
        >
          Add Services
        </button>
      </div>
    </div>
    <div class="table-responsive">
      <div class="d-flex justify-content-around" v-if="loading">
        <loader-component></loader-component>
      </div>

      <table class="table table-bordered table-hover" v-if="!loading">
        <thead class="thead-light">
          <tr>
            <th scope="col">No</th>
            <th scope="col">Title</th>
            <th scope="col">Subtitle</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="data.length == 0">
            <td colspan="7">Services is Empty</td>
          </tr>
          <tr v-for="(services, p) in data" :key="p">
            <th scope="row">{{ p + 1 }}</th>
            <td>{{ services.title }}</td>
            <td>{{ services.subtitle }}</td>
            <td>
              <div class="d-flex justify-content-around">
                <!-- <p
                  style="cursor: pointer"
                  class="btn btn-link"
                  @click.prevent="editServices(services.id)"
                >
                  <span class="material-icons"> launch </span>
                </p> -->
                <p
                  style="cursor: pointer"
                  class="btn btn-link"
                  @click.prevent="deleteServices(services.id)"
                >
                  <span class="material-icons"> delete </span>
                </p>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="d-flex justify-content-end">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li
            class="page-item"
            v-for="(link, p) in links"
            :key="p"
            @click.prevent="getAllServices(link.label)"
          >
            <a class="page-link">
              {{
                link.label == "pagination.previous"
                  ? "Prev"
                  : link.label == "pagination.next"
                  ? "Next"
                  : link.label
              }}
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import LoaderComponent from "../../components/Loader.vue";
export default {
  name: "Services",
  components: { LoaderComponent },
  data() {
    return {
      loading: true,
      data: [],
      links: [],
      next_page_url: "",
      prev_page_url: "",
    };
  },

  mounted() {
    this.getAllServices(1);
  },

  methods: {
    getAllServices(page) {
      this.loading = true;
      const endpoint = "service?page=" + page;
      this.$api.get(endpoint, (status, data, message) => {
        if (status === 200) {
          this.loading = false;
          this.data = data.services;
          this.links = data.services.links;
          this.next_page_url = data.services.next_page_url;
          this.prev_page_url = data.services.prev_page_url;
          console.log(this.data);
        } else {
          this.loading = false;
          console.log(message);
        }
      });
    },

    servicesForm() {
      this.$router.push("/admin/services/add");
    },

    deleteServices(id) {
      Vue.swal({
        title: "Are you sure?",
        text: "This banner will be delete",
        icon: "question",
        showCancelButton: true,
        cancelButtonColor: "#eb4d4b",
        confirmButtonText: "Yes, Delete!",
      }).then((result) => {
        if (result.isConfirmed) {
          this.loading = true;
          const endpoint = `service/${id}`;
          this.$api.delete(endpoint, (status, data, message) => {
            if (status === 200) {
              this.loading = false;
              Vue.swal("Success", "Services deleted", "success").then(() => {
                this.getAllServices();
              });
            } else {
              this.loading = false;
              console.log(message);
            }
          });
        }
      });
    },

    editServices(id) {
      this.$router.push(`/admin/services/edit/${id}`);
    },
  },
};
</script>
